import { render, staticRenderFns } from "./SettingsTabContent.vue?vue&type=template&id=1fb24c4d&scoped=true&"
import script from "./SettingsTabContent.vue?vue&type=script&lang=js&"
export * from "./SettingsTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb24c4d",
  null
  
)

export default component.exports